import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DataAttributeDirective } from '@shared/directives/data-attribute.directive';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { ShowContentDirective } from '@shared/directives/show-content.directive';
import { BuildType } from '@shared/enums/build.type';
import { ROUTES } from '@shared/consts/routes';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'b2b-footer-payment',
  imports: [DataAttributeDirective, NgOptimizedImage, RouterLink, TranslocoDirective, ShowContentDirective],
  templateUrl: './footer-payment.component.html',
  styleUrl: './footer-payment.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterPaymentComponent {
  protected readonly ROUTES = ROUTES;
  protected readonly BuildType = BuildType;
  protected readonly paymentImages = environment.paymentImages;
}
